/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { Button } from 'reactstrap';
import { Portfolio } from '../../types/portfolio';
import { InitiativeSearch } from '@features/search/InitiativeSearch';
import { searchInitiativeHoldings, addCompanyShareToMetricGroup } from '../../actions/initiative';
import { Loader } from '@g17eco/atoms/loader';
import { MetricGroup } from '../../types/metricGroup';
import { Suggestion } from '@g17eco/types/search';
import { useSiteAlert } from '../../hooks/useSiteAlert';
import { PACK } from '@constants/terminology';
import { BasicAlert } from '@g17eco/molecules/alert';

const initialSuggestion = { _id: '', name: '' };

const AddCompanyForm = (props: { portfolio: Portfolio, metricGroup: MetricGroup, handleReload: () => Promise<void> }) => {
  const { portfolio, metricGroup } = props;

  const groupId = metricGroup._id;
  const [suggestion, setSuggestion] = React.useState(initialSuggestion);
  const [errorMessage, setMessage] = React.useState('');
  const [isSaving, setSaving] = React.useState(false);
  const { addSiteAlert } = useSiteAlert();

  const canSubmit = !isSaving && suggestion._id;

  const handleSetCompany = (searchStr: string, suggestion?: Suggestion) => {
    if (suggestion && suggestion._id) {
      setSuggestion(suggestion);
    } else {
      setSuggestion(initialSuggestion);
    }
  };


  const handleSubmit = async () => {
    if (!canSubmit) {
      return;
    }
    setMessage('');
    if (isSaving) {
      return;
    }
    setSaving(true);
    try {
      await addCompanyShareToMetricGroup(props.portfolio._id, groupId, suggestion._id);
      addSiteAlert({ content: `The ${PACK.SINGULAR} has been sent` });
      await props.handleReload();
      setSuggestion(initialSuggestion);
    }
    catch (e) {
      setMessage(e.message);
    }
    setSaving(false);
  }

  if (isSaving || !portfolio) {
    return <Loader relative={true} />;
  }

  return (
    <>
      <h3>Assign to a new company</h3>
      <BasicAlert type='danger'>{errorMessage}</BasicAlert>
      <div className='mt-3 d-flex'>
        <div className='flex-grow-1 mr-2'>
          <InitiativeSearch
            disabled={isSaving}
            placeholder={'Search for a company'}
            searchInitiative={searchInitiativeHoldings}
            handleValueChange={handleSetCompany}
          />
        </div>
        <div>
          <Button disabled={!canSubmit} className='h-100' onClick={handleSubmit}>
            <i className='fa fa-plus mr-2' />Assign
          </Button>
        </div>
      </div>
    </>
  );
}
export default AddCompanyForm;
